export enum GroupedMedia {
  BASIC = "media",
}

export default GroupedMedia;
